import { SharedFeatureApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedFeatureApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedFeatureApi(configuration), [configuration]);
};
